import React, { useMemo } from 'react'
import { motion } from 'framer-motion'
import s from './onboarding.module.scss'
import classNames from 'classnames'
import { Button } from '@shared/ui/button/button'
import { IconCheck } from '@tabler/icons-react'
import {
	STUDENT_ONBOARDING_PREFERENCE_KEYS,
	getAvailableInstrumentItems,
	getInstrumentOptionByValue,
	getLevelOptionsByInstrumentValue,
	resolveInstrumentValueByAvailableInstrument,
} from './lib/student-onboarding-options'
import { itemVariants, optionHover, optionTap, sectionVariants } from '@shared/lib/onboarding-motion'

const {
	instrument: INSTRUMENT_KEY,
	instrumentId: INSTRUMENT_ID_KEY,
	level: LEVEL_KEY,
} = STUDENT_ONBOARDING_PREFERENCE_KEYS;

export const Goals = React.memo(({ setCurrentStep, selectedByQuestion, setSelectedByQuestion, availableInstruments }) => {
	const selectedInstrumentId = selectedByQuestion?.[INSTRUMENT_ID_KEY] || null
	const selectedInstrumentFromList = useMemo(
		() => getAvailableInstrumentItems(availableInstruments || []).find(
			(instrument) => String(instrument?.id) === String(selectedInstrumentId)
		) || null,
		[availableInstruments, selectedInstrumentId]
	)
	const selectedInstrument = selectedByQuestion?.[INSTRUMENT_KEY] ||
		resolveInstrumentValueByAvailableInstrument(selectedInstrumentFromList)
	const selectedLevel = selectedByQuestion?.[LEVEL_KEY] || ''
	const instrumentOption = getInstrumentOptionByValue(selectedInstrument)
	const levelOptions = useMemo(
		() => getLevelOptionsByInstrumentValue(selectedInstrument),
		[selectedInstrument]
	)

	const clickHandler = (level) => {
		setSelectedByQuestion((prev) => ({
			...prev,
			[INSTRUMENT_KEY]: selectedInstrument,
			[LEVEL_KEY]: level,
		}))
	}

	return (
		<motion.div className={s.slideWrapper} variants={sectionVariants} initial="initial" animate="animate">
			<motion.div className={s.titleWrapper} variants={itemVariants}>
				<p className={s.title}>Какой сейчас уровень</p>
				<p className={s.subtitle}>
					{instrumentOption?.label
						? `Выбери вариант, который лучше всего описывает твой опыт: ${instrumentOption.label.toLowerCase()}`
						: 'Выбери инструмент на предыдущем шаге, чтобы мы показали подходящие варианты'}
				</p>
			</motion.div>
			<motion.div className={s.goalOptionsGrid} variants={sectionVariants}>
				{levelOptions.map((option) => {
					const isActive = selectedLevel === option.value

					return (
						<motion.button
							key={option.value}
							type="button"
							className={classNames(s.goalOptionCard, isActive && s.active)}
							onClick={() => clickHandler(option.value)}
							variants={itemVariants}
							whileHover={optionHover}
							whileTap={optionTap}
						>
							<span className={classNames(s.goalOptionCheck, isActive && s.checked)}>
								{isActive ? <IconCheck size={14} stroke={3} /> : null}
							</span>
							<span className={s.goalOptionLabel}>{option.label}</span>
						</motion.button>
					)
				})}
			</motion.div>
			<motion.div className={s.btns} variants={itemVariants}>
				<Button
					label="Назад"
					size="small"
					theme="secondary"
					className={s.button}
					onClick={() => setCurrentStep((prev) => prev - 1)}
				/>
				<Button
					label="Далее"
					size="small"
					className={s.button}
					disabled={!selectedLevel}
					onClick={() => {
						setSelectedByQuestion((prev) => ({
							...prev,
							[INSTRUMENT_KEY]: selectedInstrument,
						}))
						setCurrentStep((prev) => prev + 1)
					}}
				/>
			</motion.div>
		</motion.div>
	)
});
